export default __webpack_public_path__ + "static/media/diners-club.5af8c833.svg";